import { inject, Injectable } from '@angular/core';

import { CapabilitiesStore, TBagsCapabilitiesFilters } from '@core/stores';
import { CapabilitiesRepository } from '@data/repositories';
import { BagCapability } from '@domain/entities';
import { Command } from '@domain/helpers';

@Injectable({
  providedIn: 'root',
})
export class CapabilityBagsBySegmentedZoneFacade {
  private readonly capabilitiesRepository = inject(CapabilitiesRepository);
  private readonly store = inject(CapabilitiesStore);

  readonly searchCapabilities = new Command<
    BagCapability[],
    TBagsCapabilitiesFilters
  >((filters: TBagsCapabilitiesFilters) =>
    this._getCapabilitiesBySemgentedZone(filters),
  );

  private async _getCapabilitiesBySemgentedZone(
    filters: TBagsCapabilitiesFilters,
  ) {
    const { date, segmentedZoneId } = filters;

    const result =
      await this.capabilitiesRepository.getBagsCapabilitiesBySegmentedZone({
        date: date.toFormat('yyyy-MM-dd'),
        id: segmentedZoneId,
      });

    if (result.isOk === false) {
      this.store.setBagCapabilities('', []);
      return result;
    }

    this.store.setBagCapabilities(segmentedZoneId, result.data);
    return result;
  }
}
